import * as React from 'react';

import styles from './EmptyCell.scss';

export const renderEmptyCell = () => (
  <div className={styles.EmptyCell}>N/A</div>
  );
